// Minimal datelist query for the duration tabs: we only need the cheapest offer's
// price for a given stay duration, so we deliberately select a single object to
// keep the payload tiny (the full datelist REST payload would be wasteful here).
export const DATE_LIST_CHEAPEST_OFFER_QUERY = `
  query GetDateListCheapestOffer($request: DateListSearchGetRequest) {
    getDateListOffers(request: $request) {
      cheapestOffer {
        totalPrice
        estimatedTotalPrice
        price
      }
    }
  }
`;
